"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CloseButton_1 = __importDefault(require("./CloseButton"));
exports.default = CloseButton_1.default;
